import { render, staticRenderFns } from "./EbookMailchimp.vue?vue&type=template&id=a651adfc&"
import script from "./EbookMailchimp.vue?vue&type=script&lang=js&"
export * from "./EbookMailchimp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports